module.exports = __webpack_public_path__ + "img/Android-store.035ebbdf.svg";